import clsx from 'clsx';
import { ComponentProps, CSSProperties, forwardRef } from 'react';
import cls from './game-cell.module.scss';

export type GameCellVariant = 'default' | 'ball' | 'choice' | 'ghost' | 'mistake';

export type GameCellBgVariant = 'lighter' | 'light' | 'default' | 'dark';

export type GameCellClassNames = Partial<
	Record<'root' | 'ball' | 'background' | 'label' | 'mistake', string>
>;

export type GameCellProps = {
	ghostDelay?: number;
	ghostDuration?: number;
	variant?: GameCellVariant;
	bgVariant?: GameCellBgVariant;
	classNames?: GameCellClassNames;
} & Omit<ComponentProps<'button'>, 'disabled'>;

export const GameCell = forwardRef<HTMLButtonElement, GameCellProps>(
	(
		{
			ghostDelay,
			ghostDuration,
			variant = 'default',
			bgVariant = 'dark',
			classNames,
			className,
			children,
			...props
		},
		ref,
	) => (
		<button
			ref={ref}
			className={clsx(cls.gameCell, className, classNames?.root)}
			data-variant={variant}
			data-bg-variant={bgVariant}
			disabled={variant !== 'choice'}
			style={
				{
					'--ghost-delay': `${ghostDelay ?? 0}ms`,
					'--ghost-duration': `${ghostDuration ?? 0}ms`,
				} as CSSProperties
			}
			{...props}
		>
			<div className={clsx(cls.gameCellBackground, classNames?.background)} />
			<div className={clsx(cls.gameCellBall, classNames?.ball)} />
			<div className={clsx(cls.gameCellMistake, classNames?.mistake)} />
			{children && <span className={clsx(cls.gameCellLabel, classNames?.label)}>{children}</span>}
		</button>
	),
);

GameCell.displayName = 'GameCell';
